export const CARDKNOX_IFIELDS_VERSION = "3.4.2602.2001";
export const CARDKNOX_IFIELDS_KEY =
  "ifields_cardcaincdev5da757da83174a21bfd202060";
